import updateIframeWidgetQuery from "../../../../graphQl/mutations/updateIframeWidget";
import {
    PAYIN_CRYPTO_TYPE_INVOICE,
    STEP_WIDGET
} from "@/public/pages/widgets/constants";


function removeEmptyFields(obj) {
    // Создаем новый объект, чтобы не изменять исходный
    const cleanedObject = {};

    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            // Проверяем, что значение не пустая строка
            if (obj[key] !== '') {
                cleanedObject[key] = obj[key];
            }
        }
    }

    return cleanedObject;
}

export const updateWidget = async ({ rootState, dispatch, rootGetters, commit }, widgetId) => {
    let widgetData;

    const widget = rootState.widgetsManage.widget

    const clearedWidget = removeEmptyFields(widget)

    const payoutCryptoCurrenciesFrom = widget.payoutCryptoCurrenciesFrom.length ? widget.payoutCryptoCurrenciesFrom.map(item => item.currency) : []
    const payinCryptoInvoiceCurrencies = widget.payinCryptoInvoiceCurrencies.length ? widget.payinCryptoInvoiceCurrencies.map(item => item.currency) : []

    const organizationId = rootGetters['app/getSelectedOrganization'].id;
    const variables = {
        organizationId,
        widgetId: widget.id,
        widget: {
            ...clearedWidget,
            payinCryptoType: widget.payinCryptoType ? widget.payinCryptoType : PAYIN_CRYPTO_TYPE_INVOICE,
            payoutCryptoCurrenciesFrom,
            payinCryptoInvoiceCurrencies,
        },
    };

    delete variables.widget.link
    delete variables.widget.id
    delete variables.widget.organizationId
    delete variables.widget.createdAt
    delete variables.widget.updatedAt
    delete variables.widget.__typename

    if (widget.payoutCrypto && !widget.payinCrypto ) {
        variables.widget.payinCryptoInvoiceCurrencies = []
        variables.widget.payinCryptoCurrenciesTo = []
    }

    if (widget.payinCrypto && !widget.payoutCrypto ) {
        variables.widget.payoutCryptoCurrenciesTo = []
        variables.widget.payoutCryptoCurrenciesFrom = []
    }

    commit('setLoading', true);

    try {
        widgetData = await dispatch('app/request', {
            type: 'mutation',
            gql: updateIframeWidgetQuery,
            variables,
        }, { root: true });
    } catch (error) {
        return error;
    } finally {
        commit('setLoading', false);
    }

    const {
        data: { updateIFrameWidget },
    } = widgetData;

    if (!updateIFrameWidget.success) {
        return { success: false }
    }

    commit('setWidget', updateIFrameWidget.result);
    commit('setCurrentStep', STEP_WIDGET)

    return updateIFrameWidget;
};
